import { createClient } from '@supabase/supabase-js'
import { appConfig } from '../config/app'
import type { Database } from '../types/database'

export const supabase = createClient<Database>(
  appConfig.supabaseUrl,
  appConfig.supabaseAnonKey,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: false,
    },
  },
)
